export const phoneRegex = /^([+0]){1}([\d\s]{8,15})$/;

export const ssnRegex =
  /^(19|20)?\d{2}(01|02|03|04|05|06|07|08|09|10|11|12)((0[1-9])|(1|2)[0-9]|(30|31))\d{4}$/;

export const licensePlateRegex = /^[A-Za-z]{3}\d{2}[A-Za-z\d]$/;
